import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import Fab from "@mui/material/Fab";
import Zoom from "@mui/material/Zoom";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";

import AddIcon from "@mui/icons-material/Add";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { useGetUserQuery } from "../user/userApiSlice";
import { useAddNewNoteMutation } from "./notesApiSlice";
import CreateIconButtons from "../../components/CreateIconButtons";

function CreateNoteArea(props) {
  const { name } = useParams();
  const { data: author } = useGetUserQuery("User");
  const [addNewNote, { isSuccess, isError, error, reset: resetAdd }] =
    useAddNewNoteMutation();
  const [note, setNote] = useState({
    title: "",
    content: "",
    author_id: "",
    labels: [],
    pinned: false,
    bgColour: "",
  });
  const [isExpanded, setExpand] = useState(false);
  function expandInputArea() {
    setExpand(true);
  }
  function handleOnChange(event) {
    const { value, name } = event.target;
    setNote((preValue) => {
      return {
        ...preValue,
        [name]: value,
      };
    });
  }
  function handleNoteBgColour(color) {
    setNote((prevState) => {
      return {
        ...prevState,
        bgColour: color,
      };
    });
  }
  function handleNotePinStatus(pin) {
    setNote((prevState) => {
      return {
        ...prevState,
        pinned: pin,
      };
    });
  }
  function onCancelLabelClicked(name) {
    let curLabels = note.labels;
    let newLabels = curLabels.filter((preItem) => {
      return preItem.name !== name;
    });
    setNote((preItems) => {
      return {
        ...preItems,
        labels: newLabels,
      };
    });
  }
  function handleNoteLabels(newLabels) {
    if (note.labels.some((e) => e._id === newLabels._id)) {
      const filteredLabels = note.labels.filter((preItem) => {
        return preItem._id !== newLabels._id;
      });
      setNote((prevState) => {
        return {
          ...prevState,
          labels: filteredLabels,
        };
      });
    } else {
      setNote((prevState) => {
        return {
          ...prevState,
          labels: [newLabels, ...prevState.labels],
        };
      });
    }
  }
  async function addNoteClicked(event) {
    await addNewNote(note);
    event.preventDefault();
  }
  useEffect(() => {
    if (author !== undefined) {
      setNote({
        title: "",
        content: "",
        author_id: author._id,
        labels: [],
        pinned: false,
        bgColour: "",
      });
    }
    if (props.labelId !== "" && props.labelId !== undefined) {
      const label = {
        _id: props.labelId,
        name: name,
      };
      setNote((prevState) => {
        return {
          ...prevState,
          labels: [label, ...prevState.labels],
        };
      });
    }
  }, [author, props.labelId, name]); //, props.labelId, name]);

  useEffect(() => {
    if (isSuccess) {
      setNote({
        title: "",
        content: "",
        author_id: author._id,
        labels: [],
        pinned: false,
        bgColour: "",
      });
      if (props.labelId !== "" && props.labelId !== undefined) {
        const label = {
          _id: props.labelId,
          name: name,
        };
        setNote((prevState) => {
          return {
            ...prevState,
            labels: [label, ...prevState.labels],
          };
        });
      }
      resetAdd();
    }
  }, [isSuccess, author, name, props.labelId, resetAdd]);
  let helperText = "";
  if (isError) {
    helperText = <p className="errmsg">{error?.data?.message}</p>;
  }
  return (
    <div>
      <form className="create-note" style={{ background: note.bgColour }}>
        {isExpanded && (
          <input
            style={{ background: note.bgColour }}
            onChange={handleOnChange}
            name="title"
            placeholder="Title"
            value={note.title}
          />
        )}
        <textarea
          style={{ background: note.bgColour }}
          onChange={handleOnChange}
          onClick={expandInputArea}
          name="content"
          placeholder="Take a note..."
          rows={isExpanded ? 3 : 1}
          value={note.content}
        />
        <Stack direction="row" spacing={0.2}>
          {note.labels?.length
            ? note.labels.map((label, i) => {
                return (
                  <Chip
                    key={i}
                    i={i}
                    size="medium"
                    label={label.name}
                    onDelete={() => onCancelLabelClicked(label.name)}
                    deleteIcon={<ClearOutlinedIcon />}
                  />
                );
              })
            : null}
        </Stack>
        <CreateIconButtons
          onBgColourClick={handleNoteBgColour}
          bgCol={note.bgColour}
          onPinClick={handleNotePinStatus}
          pinStatus={note.pinned}
          authorId={note.author_id}
          handleCheckedLabels={handleNoteLabels}
          labelsList={note.labels}
        />
        <Zoom in={isExpanded}>
          <Fab
            className="btn-add"
            type="button"
            onClick={(e) => {
              addNoteClicked(e);
            }}
          >
            <AddIcon />
          </Fab>
        </Zoom>
        {helperText}
      </form>
    </div>
  );
}

export default CreateNoteArea;
